import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CoversureLogo from "../../assets/svg/coversure-logo.svg";
import SuccessWebLogo from "../../assets/svg/web-success-otp.svg";
import SuccessMobLogo from "../../assets/svg/mob-success-otp.svg";
import ROUTE_PATH from "../../constant/route";
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../components/Toast";
import { handleInitiatePayment } from "../../store/reducers/prosure/apiThunk";
import { AppDispatch } from "../../store/store";
import {
  updateFailed,
  updateOTPDone,
  updatePayment,
  updateSuccess,
  updateTransactionTimer,
} from "../../store/reducers/prosure";

const OtpSuccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const userData = useSelector((state: any) => state);
  const {
    prosure: { formDetail, otpDone, prosureUserId },
    home: { totalPrice },
  } = userData;
  useEffect(() => {
    if (Number(totalPrice) === 0) {
      navigate(ROUTE_PATH.HOME);
    } else if (Object.keys(formDetail)?.length === 0) {
      navigate(ROUTE_PATH.CUSTOMER_DETAILS);
    }
  }, []);
  useEffect(() => {
    if (otpDone) {
      setTimeout(() => {
        dispatch(updateOTPDone(false));
        navigate(ROUTE_PATH.PAYMENT);
      }, 3000);
    } else {
      paymentInitiatedFun();
    }
  }, []);

  const paymentInitiatedFun = async () => {
    const data = {
      firstName: formDetail?.firstName,
      lastName: formDetail?.lastName,
      productInfo: "ProSure",
      amount: totalPrice,
      email: formDetail?.email,
      phone: formDetail?.mobileNo,
      surl: window.location.origin + ROUTE_PATH.SUCCESS_PAYMENT,
      furl: window.location.origin + ROUTE_PATH.FAILURE_PAYMENT,
      prosureCustomerId: prosureUserId,
    };
    try {
      const res = await dispatch(handleInitiatePayment(data)).unwrap(); // Unwraps to return raw result or throw error
      if (res?.status === 1) {
        dispatch(updatePayment(res?.data));
        dispatch(updateSuccess(false));
        dispatch(updateFailed(false));
        dispatch(updateTransactionTimer(20000))
        setTimeout(() => {
          navigate(ROUTE_PATH.PAYMENT);
        }, 3000);
      }
    } catch (error) {
      dispatch(updateFailed(false));
      dispatch(updateTransactionTimer(20000))
      dispatch(updateSuccess(false));
      showToast("Something went wrong", "error");
    }
  };
  return (
    <div className="flex items-center justify-center w-[100%] h-[100vh] bg-bg-color-3 sm:bg-bg-color-5">
      <div className="bg-bg-color-3 py-[14px] px-[16px] sm:py-[60px] sm:px-[88px] sm:rounded-[30px] bg-bg-color-3 sm:shadow-custom-light">
        <div className="flex flex-col items-center justify-center sm:mb-[36px] mb-[24px]">
          <img
            src={CoversureLogo}
            alt="CoversureLogo"
            className="hidden sm:block h-[22px]"
          />
          <img
            src={SuccessWebLogo}
            alt="SuccessWebLogo"
            className="hidden sm:block h-[110px] mt-[72px] mb-[22px]"
          />
          <img
            src={SuccessMobLogo}
            alt="SuccessMobLogo"
            className="block sm:hidden h-[60px] mb-[11px]"
          />
          <div className="sm:text-[30px] text-[16px] sm:leading-[38px] leading-[20px] sm:font-bold font-bold text-text-color-6 ">
            Awesome!
          </div>
          <div className="sm:text-[30px] text-[16px] sm:leading-[38px] leading-[20px] sm:font-bold font-bold text-text-color-6 ">
            OTP verified successfully
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtpSuccess;
